import { api } from "../app/endpoints";
import { language } from "./helpers/service-helper";

export const fetchsprzedaz = () =>
  fetch(api.sprzedaz)
    .then((res) => res.json())
    .then((data) => data.items)
    .then(language);
